import React from 'react';
import cn from 'classnames';

import ColourSwatchCard from './ColourSwatch/ColourSwatchCard';
import ColourSwatchPdp from './ColourSwatch/ColourSwatchPdp';
import { useColourPickerContext } from './ColourPickerContext';
import styles from './ColourPicker.module.scss';

const ColourSwatchGrid: React.FC = () => {
  const { state, variant } = useColourPickerContext();
  const { colours } = state;
  const isCard = variant === 'card';
  const Swatch = isCard ? ColourSwatchCard : ColourSwatchPdp;

  if (!colours.length) return null;

  return (
    <ul
      className={cn(styles.swatchList, {
        [styles.swatchListCard]: isCard,
      })}
    >
      {colours.map((colour) => (
        <li key={colour.id} className={styles.swatchListItem}>
          <Swatch colourId={colour.id} />
        </li>
      ))}
    </ul>
  );
};

export default ColourSwatchGrid;
